// extracted by mini-css-extract-plugin
module.exports = {"root":"_1u9Kl","spinner":"_15ZLt","spinner-rotate":"_3h0hq","spinnerRotate":"_3h0hq","circle":"JRGJh","spinner-dash":"_1DZtG","spinnerDash":"_1DZtG"};